webpackJsonp([213720915766396],{

/***/ 360:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(13);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _gatsbyLink = __webpack_require__(73);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(360);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Projects = function (_React$PureComponent) {
	  _inherits(Projects, _React$PureComponent);
	
	  function Projects() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Projects);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
	      filter: 'All'
	    }, _this.handleClick = function (_ref) {
	      var textContent = _ref.target.textContent;
	      return _this.setState({ filter: textContent });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Projects.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data;
	
	    var categories = data.allCosmicjsProjects.edges.map(function (_ref2) {
	      var category = _ref2.node.metadata.category;
	      return category;
	    });
	
	    categories = Array.from(new Set(categories));
	
	    return _react2.default.createElement(
	      _glamorous2.default.Div,
	      { height: '100%', display: 'flex', flexDirection: 'column' },
	      _react2.default.createElement(
	        _glamorous2.default.Div,
	        {
	          display: 'flex',
	          flex: 1,
	          css: {
	            '@media (max-width: 640px)': {
	              flexDirection: 'column'
	            }
	          }
	        },
	        _react2.default.createElement(
	          _glamorous2.default.Div,
	          {
	            height: '100%',
	            width: '20%',
	            borderRight: '2px solid #dedebe',
	            padding: '30px 0',
	            overflow: 'scroll',
	            css: {
	              '@media (max-width: 1150px)': {
	                width: '40%'
	              },
	              '@media (max-width: 640px)': {
	                width: '100%'
	              }
	            }
	          },
	          _react2.default.createElement(
	            _glamorous2.default.H1,
	            {
	              marginTop: 0,
	              padding: 20,
	              css: {
	                '@media (max-width: 640px)': {
	                  marginBottom: 0,
	                  fontSize: 28
	                }
	              }
	            },
	            'Projects'
	          ),
	          _react2.default.createElement(
	            _glamorous2.default.Div,
	            {
	              className: 'Projects__sidebar',
	              display: 'flex',
	              flexDirection: 'column'
	            },
	            _react2.default.createElement(
	              'button',
	              {
	                className: this.state.filter === 'All' && 'active',
	                onClick: this.handleClick
	              },
	              'All'
	            ),
	            categories.map(function (category) {
	              return _react2.default.createElement(
	                'button',
	                {
	                  key: category,
	                  className: _this2.state.filter === category && 'active',
	                  onClick: _this2.handleClick
	                },
	                category
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _glamorous2.default.Div,
	          {
	            flex: 1,
	            overflowY: 'scroll',
	            display: 'grid',
	            gridTemplateColumns: 'repeat(3, 1fr)',
	            gridGap: 2,
	            padding: 1,
	            gridAutoRows: 250,
	            css: {
	              '@media (max-width: 1150px)': {
	                gridTemplateColumns: 'repeat(2, 1fr)'
	              },
	              '@media (max-width: 880px)': {
	                gridTemplateColumns: '1fr',
	                gridAutoRows: 200,
	                overflowY: 'hidden'
	              }
	            }
	          },
	          data.allCosmicjsProjects.edges.map(function (_ref3) {
	            var _ref3$node = _ref3.node,
	                slug = _ref3$node.slug,
	                _ref3$node$metadata = _ref3$node.metadata,
	                imgix_url = _ref3$node$metadata.hero.imgix_url,
	                category = _ref3$node$metadata.category,
	                title = _ref3$node.title;
	            return (_this2.state.filter === category || _this2.state.filter === 'All') && _react2.default.createElement(
	              'div',
	              { className: 'Projects__image-wrapper' },
	              _react2.default.createElement(_glamorous2.default.Img, {
	                width: '100%',
	                height: '100%',
	                objectFit: 'cover',
	                margin: 0,
	                src: imgix_url,
	                alt: title
	              }),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/projects/' + slug, key: title },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'Projects__overlay' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    title
	                  )
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Projects;
	}(_react2.default.PureComponent);
	
	// c
	
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(13);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(22);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _projects = __webpack_require__(245);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _subNav = __webpack_require__(29);
	
	var _subNav2 = _interopRequireDefault(_subNav);
	
	var _Carousel = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _gatsbyPluginPageTransitions2.default,
	    {
	      defaultStyle: {
	        transition: '750ms',
	        height: 'calc(100vh - 50px)',
	        transform: 'translateY(-100%)'
	      },
	      transitionStyles: {
	        entering: { transform: 'translateY(-100%)' },
	        entered: { transform: 'none' }
	      },
	      transitionTime: 750
	    },
	    _react2.default.createElement(
	      _glamorous2.default.Div,
	      {
	        backgroundColor: 'rgba(255, 255, 255, 0.8)',
	        flex: 1,
	        margin: 20,
	        display: 'flex',
	        flexDirection: 'column',
	        height: '95%',
	        borderRadius: 4,
	        css: {
	          '@media (max-width: 880px)': {
	            height: 'auto',
	            minHeight: '95%'
	          }
	        }
	      },
	      _react2.default.createElement(_subNav2.default, { navLinks: ['Home', 'Contact', 'About', 'News'] }),
	      _react2.default.createElement(_projects2.default, { data: data })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-198f32e46025db1cb51e.js